import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import AnimatedBackground from '../components/AnimatedBackground';
import InterestTag from '../components/InterestTag';
import { useUI } from '../contexts/UIContext';
import { useAuth } from '../contexts/AuthContext';
import { INTEREST_OPTIONS } from '../utils/constants';

/**
 * İlgi Alanları Seçim Ekranı
 * Kullanıcının ilgi alanlarını seçtiği ekran
 */
const InterestSelectionScreen = () => {
  const { navigateToScreen } = useUI();
  const { register } = useAuth();
  
  // İlgi alanları seçimi
  const [interestSelections, setInterestSelections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // İlgi alanı seçimi değiştirme
  const toggleInterest = (interest) => {
    if (interestSelections.includes(interest)) {
      setInterestSelections(interestSelections.filter(item => item !== interest));
    } else {
      setInterestSelections([...interestSelections, interest]);
    }
  };

  // Hesap oluşturma işlemi
  const handleCreateAccount = async () => {
    setIsLoading(true);
    setError('');
    
    try {
      // İleriki geliştirmelerde: Burada API kullanarak hesap oluşturabiliriz
      // İlgi alanları da dahil edilebilir
      
      // Hesap oluşturma başarılı sayfasına yönlendir
      setTimeout(() => {
        navigateToScreen('accountCreatedSuccess');
      }, 1000);
    } catch (err) {
      setError('Hesap oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AnimatedBackground>
      {/* Logo */}
      <div className="w-20 h-20 mb-6 bg-white rounded-full flex items-center justify-center">
        <div className="text-2xl font-bold text-blue-600 flex items-center">
          <span className="text-blue-600">i</span>
          <span className="text-blue-600">d</span>
        </div>
      </div>
      
      {/* Swipe indicator - iOS style */}
      <div className="w-12 h-1.5 bg-gray-300 rounded-full mb-8" />
      
      {/* Üst Bar ve Geri Tuşu */}
      <div className="w-full flex items-center mb-4">
        <button
          className="p-2 rounded-full hover:bg-gray-100"
          onClick={() => navigateToScreen('accountInfo')}
        >
          <ArrowLeft size={24} />
        </button>
        <div className="flex-1"></div>
      </div>
      
      {/* Başlık */}
      <h1 className="text-2xl font-bold text-center mb-2">
        İlgi alanlarını seç
      </h1>
      <p className="text-gray-500 text-center mb-6">
        Sana ilgilendiğin şeyleri daha çok gösterebilmemiz için bize yardımcı ol
      </p>
      
      {/* Hata mesajı */}
      {error && (
        <div className="w-full bg-red-100 border-l-4 border-red-500 text-red-700 p-3 mb-4 rounded">
          <p>{error}</p>
        </div>
      )}
      
      {/* İlgi Alanları Seçimi */}
      <div className="space-y-4">
        {INTEREST_OPTIONS.map((category, idx) => (
          <div key={idx}>
            <div className="flex flex-wrap gap-2 mb-2">
              <InterestTag
                label={category.category}
                selected={interestSelections.includes(category.category)}
                onToggle={() => toggleInterest(category.category)}
                isCategory={true}
              />
              
              {category.tags.map((tag, tagIdx) => (
                <InterestTag
                  key={tagIdx}
                  label={tag}
                  selected={interestSelections.includes(tag)}
                  onToggle={() => toggleInterest(tag)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <button 
        onClick={handleCreateAccount}
        className="w-full py-4 bg-blue-500 text-white font-semibold rounded-xl text-lg mt-8"
        disabled={isLoading}
      >
        {isLoading ? 'Hesap oluşturuluyor...' : 'Hesabını oluştur'}
      </button>
      
      <p className="text-xs text-center text-gray-500 mt-2">
        Hesap oluşturarak <span className="text-blue-600">Şartlar ve Koşullar</span> ile
        <span className="text-blue-600"> Kullanıcı Gizlilik Sözleşmesi</span> içeriklerini kabul etmiş olursun.
      </p>
    </AnimatedBackground>
  );
};

export default InterestSelectionScreen;
